module.exports = __webpack_public_path__ + "img/banner-m-bg.20dc00ef.png";